import BackboneElement from './BackboneElement';
import merge from 'lodash/merge';
import Coding from './types/Coding';

export default class BN_SuperBillProcedureCode extends BackboneElement {
    static __className = 'BN_SuperBillProcedureCode';

    __objectStructure = {
        code: Coding,
        date: String,
    };

    constructor(constructJson, className = 'BN_SuperBillProcedureCode') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
